<template>
  <div class="airport-container">
    <div class="banner">
      <img
        src="https://scheme.timesmedia.com.cn/activity/airport/top_banner_text.png"
        class="banner-img-text"
      />
      <img src="https://scheme.timesmedia.com.cn/activity/airport/top_banner.png" class="banner-img" />
      <img
        src="https://scheme.timesmedia.com.cn/activity/airport/media-750/top_banner.png"
        class="banner-img-750"
      />
    </div>

    <div class="main">
      <div v-if="info && info.information && info.information.banner && info.information.banner.length" class="main-banner">
        <swiper style="width: 100%;height: 100%;" :options="swiperOption">
          <swiper-slide class="swiper-slide" v-for="(item,index) in info.information.banner" :key="index">
            <div @click.stop="onLink(item.link)" class="swiper-img-box">
              <!-- <div class="mask" /> -->
              <img :src="item.banner" style="object-fit: cover;"/>
              <!-- <div class="content">
                <p class="up">{{ item.title }}</p>
                <p class="down ellipsis">{{ item.summary }}</p>
              </div> -->
            </div>
          </swiper-slide>
          <!-- 分页器 -->
          <div class="swiper-air-pagination"  slot="pagination"></div>
            <!-- 左右箭头 -->
          <!-- <div @click.stop class="swiper-button-prev" slot="button-prev"></div>
          <div @click.stop class="swiper-button-next" slot="button-next"></div>  -->
        </swiper>
      </div>
      <div v-if="info && info.information && info.information.arts && info.information.arts.length" class="main-more">
        <template v-for="(v, i) in info.information.arts">
          <div @click="onLink(v.link)" v-if="isShow || i < 5" :key="i" class="more-item ellipsis pointer">{{ v.title }}</div>
        </template>
        <div @click="isShow = true" v-if="info.information.arts.length > 5 && !isShow" class="more-btn pointer">查看更多...</div>
      </div>
      <div class="main-background">
        <div class="main-background-title"></div>
        <div class="main-background-text">
          <p>
            （中国）广州商务航空展是由广州空港经济区管理委员会、广东省机场管理集团有限公司主办，广东省机场管理集团翼通商务航空服务有限公司、广东时代传媒集团有限公司承办的商务航空展，是国内第一个自主创办商务航空展的品牌。
          </p>
          <p>
            （中国）广州商务航空展自2018年创办以来，已成功举办了四届，历经四届航展的打造，（中国）广州商务航空展已成为行业一大盛事，乃至全国商务航空最具有影响力的活动品牌，既是宣传展示广州风采和行业发展水平的窗口，也是捕捉行业创新业态趋势、共商行业发展的沟通交流平台，具有良好的业界口碑和品牌价值。
          </p>
        </div>
      </div>
      <div class="main-exhibition">
        <div class="exhibition-title" />
        <img
          src="https://scheme.timesmedia.com.cn/activity/airport/exhibition.png"
          class="exhibition-img"
        />
        <img
          src="https://scheme.timesmedia.com.cn/activity/airport/media-750/exhibition.png"
          class="exhibition-img-750"
        />
      </div>
      <!-- <div class="main-five">
        <div class="five-title" />
        <div class="five-box">
          <div v-for="(v, i) in fiveList" :key="i" class="five-items">
            <div class="five-items-img">
              <img :src="v.img" class="img" />
              <img :src="v.img750" class="img-750" />
            </div>
            <div class="five-items-text">
              <p class="label ellipsis">{{ v.label }}</p>
              <p class="summary">{{ v.summary }}</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="main-influence">
        <div class="influence-title" />
        <div class="influence-box">
          <div class="influence-items">
            <div class="items-title">
              <span>介绍</span>
            </div>
            <p class="items-text">
              “影响力·中国”时代峰会是广东时代传媒集团精心打造的系列高端峰会，汇聚学术界、思想界、产业界最具影响力的先驱者与决策者，权威解读最新经济政策和经济热点，共同探索中国经济新趋势，为持续提升中国经济实力与中国企业影响力建言献策。峰会迄今已成功举办八届，参会人数共4000余人，影响了众多企业家、金融家、经济学者和媒体人，建立了良好的品牌形象、美誉度及影响力。
            </p>
          </div>
          <div class="influence-items">
            <div class="items-title">
              <span>主题</span>
            </div>
            <div class="items-text">
              <p class="items-text-t">从春天出发，踏上高质量发展新征程</p>
              <p>
                从"经济新常态"到"新发展格局"，我们正踏上高质量发展新征程。<br />
                2022年，中国经济迎难而进，产业链供应链总体稳固，科技创新成果丰硕，中国经济稳中向好、长期向好的基本面没有改变，转型升级、高质量发展的大势没有改变。2023年是全面贯彻落实党的二十大精神的开局之年，是实施“十四五”规划承前启后的关键一年，锚定高质量发展，着力构建新发展格局，是新时代中国经济发展的鲜明主题。<br />
                在此背景下，本届峰会围绕中国宏观经济新逻辑、高质量发展新模式、经济改革发展新能等社会热点议题展开讨论，深入研判。
              </p>
            </div>
          </div>
          <div class="influence-items">
            <div class="items-title">
              <span>主论坛</span>
            </div>
            <div class="items-text">
              <p class="items-text-t">影响力·中国&nbsp;&nbsp;时代峰会</p>
              <p>
                我们将邀请知名经济学家，以及来自银行、基金、保险、上市公司、航空企业的高管出席盛会，一起聚焦高质量发展，探讨经济新动能，共同展望中国经济新未来，唱响“春天的故事”！
              </p>
            </div>
          </div>
          <div class="influence-items">
            <div class="items-title">
              <span>分论坛</span>
            </div>
            <div class="items-text">
              <div class="sp-box">
                <div class="sp-items sp-bg-1">
                  <p>经济视野论坛</p>
                </div>
                <div class="sp-items sp-bg-2">
                  <p>中国商务航空发展高峰论坛</p>
                </div>
                <!-- <div class="sp-items sp-bg-3">
                  <p>商务航空论坛</p>
                </div> -->
                <!-- <div class="sp-items sp-bg-4">
                  <p>新经济论坛</p>
                </div> -->
              </div>
              <!-- <p>
                围绕中国金融变革新趋势、商务航空发展新变化、上市公司创新新路径等热点话题展开讨论，深入研判前沿，加强行业交流与合作。
              </p> -->
            </div>
          </div>
          <!-- <div class="influence-items">
            <div class="items-title">
              <span>时代金翼奖</span>
            </div>
            <div class="items-text">
              <p class="items-text-t">官方X行业权威的商务航空榜单</p>
              <p>
                “时代金翼奖”着眼“赋能、服务、科技”，评选航空行业各领域的领军者，记录中国航空行业的发展榜样，旨在汇聚更多的科技与力量以面对多元又充满未知的经济环境，共同助力航空行业的健康稳定发展。
              </p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="main-past">
        <div class="past-title" />
        <div class="past-box">
          <div v-for="(v, i) in pastList" :key="i" class="past-items">
            <div class="items-cover">
              <img :src="v.cover" />
              <span class="cover-tip">{{ v.tip }}</span>
            </div>
            <p class="items-time">{{ v.time }}</p>
            <p class="items-conetnt">{{ v.label }}</p>
          </div>
        </div>
      </div>
      <div class="main-organization">
        <div class="organization-title" />
        <div class="organization-box">
          <div class="organization-items">
            <p class="items-title">主办单位</p>
            <p class="items-content">广州空港经济区管理委员会</p>
            <p class="items-content">广东省机场管理集团有限公司</p>
          </div>

          <div class="organization-items">
            <p class="items-title">承办单位</p>
            <p class="items-content">
              广东省机场管理集团翼通商务航空服务有限公司
            </p>
            <p class="items-content">广东时代传媒集团有限公司</p>
          </div>
        </div>
        <div class="organization-box">
          <div class="organization-items">
            <p class="items-title">协办单位</p>
            <p class="items-content">时代周报、新周刊、时代财经、消费者报道</p>
            <p class="items-content">时代商学院、时代数据、创业圈、葡萄酒</p>
            <p class="items-content">收藏拍卖、少年文摘</p>
            <!-- <p class="items-content">新周刊</p>
            <p class="items-content">时代财经</p>
            <p class="items-content">消费者报道</p>
            <p class="items-content">时代商学院</p>
            <p class="items-content">时代数据</p>
            <p class="items-content">创业圈</p>
            <p class="items-content">葡萄酒</p>
            <p class="items-content">收藏拍卖</p>
            <p class="items-content">少年文摘</p> -->
            <p class="items-content">亚洲商务航空协会</p>
            <p class="items-content">北京商务航空协会</p>
            <p class="items-content">广东省通用航空协会</p>
          </div>
        </div>
      </div>
      <!-- <div class="main-naming">
        <div class="naming-title" />
        <div class="naming-box">
          <div class="naming-item">
            <img src="https://scheme.timesmedia.com.cn/activity/airport/naming/richang.png" />
          </div>
        </div>
      </div> -->
      <div class="main-media">
        <div class="media-title" />
        <img
          src="https://scheme.timesmedia.com.cn/activity/airport/media-background.png"
          class="media-img"
        />
        <img
          src="https://scheme.timesmedia.com.cn/activity/airport/media-750/media-background.png"
          class="media-img-750"
        />
      </div>
      <div class="main-us">
        <div class="us-title" />
        <p class="us-content">
          <span style="font-weight: bold; color: #003bd0">苏先生：</span>
          13632224373 sujinping@timesmedia.com.cn
        </p>
        <p class="us-content">
          <span style="font-weight: bold; color: #003bd0">丁女士：</span>
          13926132525 dingqiaoyi@gdairport.com
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: null,
      isShow: false,
      swiperOption:{
        //显示分页
        pagination: {
          el: '.swiper-air-pagination'
        },
        //设置点击箭头
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        //自动轮播
        // autoplay: {
        //   delay: 2000,
        //   //当用户滑动图片后继续自动轮播
        //   disableOnInteraction: false,
        // },
        //开启循环模式
        loop: false
      },
      fiveList: [
        {
          label: "商务航空",
          summary:
            "飞机制造商、运营商、商务航空公司、FBO运营商、其他商务航空产业链企业",
          img: "https://scheme.timesmedia.com.cn/activity/airport/five/pic-1.png",
          img750: "https://scheme.timesmedia.com.cn/activity/airport/media-750/five/pic-1.png",
        },
        {
          label: "双碳与新能源",
          summary: "新能源车、风电、光伏",
          img: "https://scheme.timesmedia.com.cn/activity/airport/five/pic-2.png",
          img750: "https://scheme.timesmedia.com.cn/activity/airport/media-750/five/pic-2.png",
        },
        {
          label: "先锋跨界",
          summary: "一线品牌、联名跨界",
          img: "https://scheme.timesmedia.com.cn/activity/airport/five/pic-3.png",
          img750: "https://scheme.timesmedia.com.cn/activity/airport/media-750/five/pic-3.png",
        },
        {
          label: "大湾区文化 ",
          summary: "湾区文化品牌、湾区非遗文化",
          img: "https://scheme.timesmedia.com.cn/activity/airport/five/pic-4.png",
          img750: "https://scheme.timesmedia.com.cn/activity/airport/media-750/five/pic-4.png",
        },
        {
          label: "Z世代潮玩",
          summary: "国潮、潮玩、文创产业",
          img: "https://scheme.timesmedia.com.cn/activity/airport/five/pic-5.png",
          img750: "https://scheme.timesmedia.com.cn/activity/airport/media-750/five/pic-5.png",
        },
      ],
      pastList: [
        {
          label:
            "第一届（中国）广州商务航空展暨大中华地区轻型公务机发展高峰论坛",
          time: "2018.10.31-11.1",
          cover: "https://scheme.timesmedia.com.cn/activity/airport/past/pic-1.png",
          tip: "第一届",
        },
        {
          label:
            "第二届（中国）广州商务航空展暨大中华地区轻型公务机发展高峰论坛",
          time: "2019.11.6 -11.7",
          cover: "https://scheme.timesmedia.com.cn/activity/airport/past/pic-2.png",
          tip: "第二届",
        },
        {
          label:
            "第三届（中国）广州商务航空展暨粤港澳大湾区世界一流公务机运营管理中心高峰论坛",
          time: "2020.11.6-11.7",
          cover: "https://scheme.timesmedia.com.cn/activity/airport/past/pic-3.png",
          tip: "第三届",
        },
        {
          label: "第四届（中国）广州商务航空展暨2021中国商务航空发展高峰论坛",
          time: "2021.11.6 -11.7",
          cover: "https://scheme.timesmedia.com.cn/activity/airport/past/pic-4.png",
          tip: "第四届",
        },
      ],
    };
  },
  methods: {
    getTopicsInfo() {
      const forum_id = this.$route.query.forum_id === 'airport' ? 10 : this.$route.query.forum_id || 10;

      this.$api.topics.getTopicsInfo({ forum_id }).then((res) => {
        if (res.status === "success") {
          this.info = res.data;
          document.title = "第五届（中国）广州商务航空展暨2022“影响力·中国”时代峰会";
        }
      });
    },
    onLink(link = null) {
      if (!link) {
        return;
      }

      window.open(link);
    },
  },
  created() {
    this.getTopicsInfo()
  }
};
</script>

<style>
html,
body {
  min-width: 0;
  height: auto;
  min-height: 100%;
  background: rgb(244, 247, 255);
}
@media screen and (max-width: 780px) {
  html,
  body {
    background: #0b1681;
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";
.airport-container {
  width: 100%;
  .banner {
    position: relative;
    width: 100%;
    font-size: 0;
    .banner-img-text {
      position: absolute;
      width: 62%;
      top: calc(100vw * 0.043);
      left: 0;
      right: 0;
      margin: auto;
      z-index: 1;
    }
    .banner-img {
      display: block;
    }
    .banner-img-750 {
      display: none;
    }
    img {
      display: block;
      width: 100%;
    }
  }
  .main {
    position: relative;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    margin-top: calc(-100vw * 0.406);
    z-index: 1;
    .main-background {
      width: 100%;
      padding: 54px 170px 70px;
      background: #172d8f;
      box-sizing: border-box;
      &-title {
        width: 159px;
        height: 48px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/bg-title.png") no-repeat;
        background-size: 100%;
        margin: auto;
        margin-bottom: 27px;
      }
      &-text {
        position: relative;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        > p:not(:last-child) {
          text-align: justify;
          margin-bottom: 20px;
        }
        &::after {
          content: "";
          position: absolute;
          width: 4px;
          height: calc(100% - 4px);
          background: #1c62f5;
          left: -30px;
          top: 4px;
          z-index: 1;
        }
      }
    }
    .main-banner {
      width: 100%;
      height: 491px;
    }
    .main-more {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      padding: 60px 100px 49px;
      background: #fff;
      .more-item {
        width: 400px;
        margin-bottom: 16px;
        font-size: 16px;
        color: #000000;
        line-height: normal;
        &:nth-child(2n) {
          text-align: right;
        }
      }
      .more-btn {
        font-size: 16px;
        font-weight: 400;
        color: #172D8F;
        margin-bottom: 16px;
      }
    }
    .main-exhibition {
      width: 100%;
      font-size: 0;
      .exhibition-title {
        display: none;
      }
      .exhibition-img {
        display: block;
      }
      .exhibition-img-750 {
        display: none;
      }
      img {
        display: block;
        width: 100%;
      }
    }
    .main-five {
      width: 100%;
      padding: 60px 100px 50px;
      background: #fff;
      box-sizing: 100%;
      .five-title {
        width: 172px;
        height: 39px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/five-title.png") no-repeat;
        background-size: 100%;
        margin: auto;
        margin-bottom: 70px;
      }
      .five-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .five-items {
          width: 180px;
          height: 360px;
          background: #f6f9ff;
          margin-bottom: 24px;
          .five-items-img {
            width: 100%;
            height: 234px;
            .img {
              display: block;
            }
            .img-750 {
              display: none;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .five-items-text {
            width: 100%;
            height: calc(100% - 234px);
            padding: 13px 13px 0;
            box-sizing: border-box;
            .label {
              font-size: 16px;
              font-weight: bold;
              color: #003bd0;
              margin-bottom: 12px;
            }
            .summary {
              @include ellipsis(4);
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              line-height: 16px;
            }
          }
        }
      }
    }
    .main-influence {
      position: relative;
      width: 100%;
      background: url("https://scheme.timesmedia.com.cn/activity/airport/influence-background.png")
        no-repeat;
      padding: 102px 178px 166px;
      background-size: 100% 100%;
      // background-attachment:fixed;
      &::after {
        position: absolute;
        content: "";
        width: 100%;
        height: 50%;
        background: #fff;
        left: 0;
        top: 0;
        z-index: -1;
      }
      &::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 50%;
        background: rgb(241, 242, 255);
        left: 0;
        bottom: -60px;
        z-index: -1;
      }
      .influence-title {
        width: 307px;
        height: 57px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/influence-title.png")
          no-repeat;
        background-size: 100% 100%;
        margin: 0 auto 45px;
      }
      .influence-box {
        .influence-items {
          &:not(:last-child) {
            margin-bottom: 50px;
          }
          .items-title {
            position: relative;
            display: inline-block;
            min-width: 93px;
            padding: 3px 20px;
            font-size: 18px;
            font-weight: bold;
            color: #002a90;
            line-height: 18px;
            margin-bottom: 28px;
            > span {
              position: relative;
              display: inline-block;
              width: 100%;
              text-align: justify;
              text-align-last: justify;
              z-index: 2;
            }
            &::after {
              position: absolute;
              content: "";
              width: calc(100% - 10px);
              height: 100%;
              background: #fff;
              transform: skew(20deg);
              left: 0;
              right: 0;
              top: 0;
              margin: auto;
              z-index: 1;
            }
          }
          .items-text {
            position: relative;
            width: 100%;
            padding-left: 16px;
            font-size: 13px;
            color: #ffffff;
            line-height: 24px;
            text-align: justify;
            &::after {
              position: absolute;
              content: "";
              width: 1px;
              height: calc(100% - 9px);
              background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 0.2),
                rgba(255, 255, 255, 0.7)
              );
              left: 0;
              top: 5px;
              z-index: 1;
            }
            .items-text-t {
              font-size: 16px;
              margin-bottom: 14px;
            }
            .sp-box {
              display: flex;
              flex-wrap: wrap;
              padding-top: 5px;
              .sp-items {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 144px;
                height: 125px;
                padding: 0 10px;
                margin-bottom: 2px;
                text-align: center;
                box-sizing: border-box;
                font-size: 16px;
                font-weight: 300;
                color: #ffffff;
                @for $var from 1 to 5 {
                  &.sp-bg-#{$var} {
                    background: url("https://scheme.timesmedia.com.cn/activity/airport/kuang/kuang-#{$var}.png")
                      no-repeat;
                    background-size: 100% 100%;
                  }
                }
                &:not(:last-child) {
                  margin-right: 50px;
                }
              }
            }
          }
        }
      }
    }
    .main-past {
      position: relative;
      width: 100%;
      padding: 98px 100px 125px;
      margin-top: -60px;
      background: url("https://scheme.timesmedia.com.cn/activity/airport/past-background.png") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      &::after {
        position: absolute;
        content: "";
        width: 100%;
        height: 50%;
        background: #fff;
        left: 0;
        bottom: 0;
        z-index: -1;
      }
      .past-title {
        width: 146px;
        height: 39px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/past-title.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto 56px;
      }
      .past-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .past-items {
          width: 239px;
          margin-bottom: 25px;
          .items-cover {
            position: relative;
            width: 100%;
            padding-bottom: 33px;
            margin-bottom: 24px;
            border-bottom: 1px solid #000d73;
            font-size: 0;
            box-sizing: border-box;
            > img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .cover-tip {
              position: absolute;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              width: 77px;
              height: 26px;
              padding-right: 8px;
              background: rgb(0, 59, 208);
              border-radius: 0 0 0 13px;
              font-size: 15px;
              color: #fff;
              line-height: 15px;
              box-sizing: border-box;
              bottom: 20px;
              right: 0;
              z-index: 1;
            }
          }
          .items-time {
            margin-bottom: 13px;
            font-size: 14px;
            color: #999999;
            line-height: 14px;
          }
          .items-conetnt {
            @include ellipsis(2);
            font-size: 16px;
            font-weight: 400;
            color: #444444;
            line-height: 24px;
          }
        }
      }
    }
    .main-organization {
      width: 100%;
      background: #fff;
      padding: 30px 170px 85px;
      .organization-title {
        width: 165px;
        height: 40px;
        margin: 0 auto 68px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/organization-title.png")
          no-repeat;
        background-size: 100% 100%;
      }
      .organization-box {
        display: flex;
        &:not(:last-child) {
          margin-bottom: 56px;
        }
        .organization-items {
          position: relative;
          flex: 1;
          max-width: 340px;
          font-size: 16px;
          line-height: 20px;
          z-index: 1;
          &::after {
            position: absolute;
            content: "";
            width: 22px;
            height: 22px;
            background: url("https://scheme.timesmedia.com.cn/activity/airport/organization-icon.png")
              no-repeat;
            background-size: 100% 100%;
            top: -5px;
            left: -12px;
            z-index: 1;
          }
          &:not(:last-child) {
            margin-right: 170px;
          }
          .items-title {
            margin-bottom: 15px;
            font-weight: bold;
            color: #003bd0;
          }
          .items-content {
            color: #333333;
          }
        }
      }
    }
    .main-naming {
      width: 100%;
      background: #fff;
      padding-bottom: 69px;
      .naming-title {
        width: 175px;
        height: 39px;
        margin: 0 auto 39px;
        background-image: url("https://scheme.timesmedia.com.cn/activity/airport/naming-title.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .naming-box {
        display: flex;
        justify-content: center;
        align-items: center;
        .naming-item {
          width: 98px;
          img {
            width: 100%;
          }
        }
      }
    }
    .main-media {
      width: 100%;
      background: #fff;
      .media-title {
        display: none;
      }
      .media-img {
        display: block;
      }
      .media-img-750 {
        display: none;
      }
      img {
        width: 100%;
      }
    }
    .main-us {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 96px 0;
      background: #fff;
      box-sizing: border-box;
      .us-title {
        width: 127px;
        height: 39px;
        margin-bottom: 75px;
        background: url("https://scheme.timesmedia.com.cn/activity/airport/us-title.png") no-repeat;
        background-size: 100% 100%;
      }
      .us-content {
        font-size: 16px;
        color: #333333;
        line-height: 30px;
      }
    }
  }
}

@media screen and (max-width: 780px) {
  .airport-container {
    .banner {
      .banner-img-text {
        display: none;
      }
      .banner-img {
        display: none;
      }
      .banner-img-750 {
        display: block;
      }
    }
    .main {
      margin-top: calc(-100vw * 0.454);
      .main-banner {
        width: 100%;
        height: 350px;
        padding: 0 66px;
      }
      .main-more {
        width: 100%;
        padding: 33px 66px 66px;
        background: transparent;
        .more-item {
          width: 100%;
          margin-bottom: 20px;
          font-size: 24px;
          color: #FFFFFF;
          &:nth-child(2n) {
            text-align: left;
          }
        }
        .more-btn {
          font-size: 24px;
          font-weight: 400;
          color: #B0B0B0;
          margin-top: 29px;
          margin-bottom: 0;
        }
      }
      .main-background {
        padding: 0 66px 104px;
        background: transparent;
        &-title {
          width: 194px;
          height: 82px;
          background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/bg-title.png");
          margin: 0 0 62px;
        }
        &-text {
          font-size: 24px;
          line-height: 30px;
          > p:not(:last-child) {
            margin-bottom: 20px;
          }
          &::after {
            display: none;
          }
        }
      }
      .main-exhibition {
        .exhibition-title {
          display: block;
          width: 227px;
          height: 75px;
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/exhibition-title.png")
            no-repeat;
          background-size: 100% 100%;
          margin: 0 0 10px 66px;
        }
        .exhibition-img {
          display: none;
        }
        .exhibition-img-750 {
          display: block;
        }
      }
      .main-five {
        padding: 65px 66px 0;
        background: transparent;
        .five-title {
          width: 218px;
          height: 79px;
          margin: 0 0 52px;
          background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/five-title.png");
        }
        .five-box {
          display: block;
          .five-items {
            width: 100%;
            height: auto;
            margin: 0;
            background: #fff;
            &:not(:last-child) {
              margin-bottom: 33px;
            }
            .five-items-img {
              width: 100%;
              height: auto;
              font-size: 0;
              .img {
                display: none;
              }
              .img-750 {
                display: block;
              }
              img {
                display: block;
                width: 100%;
                height: auto;
              }
            }
            .five-items-text {
              width: 100%;
              height: auto;
              min-height: 138px;
              padding: 17px 19px;
              .label {
                font-size: 28px;
                line-height: normal;
                margin-bottom: 18px;
              }
              .summary {
                @include ellipsis(2);
                font-size: 24px;
                line-height: normal;
              }
            }
          }
        }
      }
      .main-influence {
        padding: 67px 66px 0;
        background: transparent;
        &::after {
          display: none;
        }
        &::before {
          display: none;
        }
        .influence-title {
          width: 394px;
          height: 84px;
          background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/influence-title.png");
          margin: 0 0 60px;
        }
        .influence-box {
          .influence-items {
            .items-title {
              min-width: 120px;
              padding: 4px 20px;
              font-size: 28px;
              line-height: 28px;
              margin-bottom: 26px;
            }
            .items-text {
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
              .items-text-t {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 24px;
              }
              .sp-box {
                .sp-items {
                  width: 228px;
                  height: 133px;
                  padding: 0;
                  font-size: 0;
                  @for $var from 1 to 5 {
                    &.sp-bg-#{$var} {
                      background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/kuang/kuang-#{$var}.png");
                    }
                  }
                  &:not(:last-child) {
                    margin-right: 37px;
                  }
                }
              }
            }
          }
        }
      }
      .main-past {
        padding: 100px 66px;
        padding-bottom: calc(100vw * 0.097);
        margin-top: 0;
        background: transparent;
        &::after {
          width: 100%;
          height: calc(100vw * 0.097);
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/past-background.png")
            no-repeat;
          background-size: 100% 100%;
          z-index: 1;
        }
        .past-title {
          width: 183px;
          height: 79px;
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/past-title.png")
            no-repeat;
          background-size: 100% 100%;
          margin: 0 0 68px;
        }
        .past-box {
          .past-items {
            width: calc((100% - 29px) / 2);
            margin-bottom: 64px;
            .items-cover {
              padding-bottom: 38px;
              margin-bottom: 27px;
              border-color: #ffffff;
              .cover-tip {
                width: 93px;
                height: 31px;
                padding-right: 14px;
                font-size: 20px;
                line-height: 20px;
                border-radius: 0 0 0 15.5px;
                bottom: 26px;
                right: 0;
              }
            }
            .items-time {
              font-size: 24px;
              line-height: 24px;
              margin-bottom: 24px;
              color: #c5c3c3;
            }
            .items-conetnt {
              @include ellipsis(3);
              font-size: 24px;
              font-weight: 400;
              color: #ffffff;
              line-height: 29px;
            }
          }
        }
      }
      .main-organization {
        padding: 17px 66px 97px;
        .organization-title {
          width: 208px;
          height: 79px;
          margin: 0 0 51px;
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/organization-title.png")
            no-repeat;
          background-size: 100% 100%;
        }
        .organization-box {
          display: block;
          &:not(:last-child) {
            margin-bottom: 47px;
          }
          .organization-items {
            width: 100%;
            max-width: none;
            font-size: 24px;
            line-height: 30px;
            &:not(:last-child) {
              margin-bottom: 47px;
            }
            &::after {
              width: 34px;
              height: 34px;
              top: -12px;
              left: -16px;
            }
            .items-title {
              margin-bottom: 26px;
            }
          }
        }
      }
      .main-naming {
        padding: 0 66px 69px;
        .naming-title {
          width: 217px;
          height: 77px;
          margin: 0 0 43px;
          background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/naming-title.png");
        }
        .naming-box {
          justify-content: flex-start;
          align-items: flex-start;
          .naming-item {
            width: 78px;
          }
        }
      }
      .main-media {
        width: 100%;
        padding: 0 66px;
        background: #fff;
        .media-title {
          display: block;
          width: 153px;
          height: 77px;
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/media-title.png")
            no-repeat;
          background-size: 100% 100%;
          margin-bottom: 53px;
        }
        .media-img {
          display: none;
        }
        .media-img-750 {
          display: block;
        }
        img {
          width: 100%;
        }
      }
      .main-us {
        align-items: flex-start;
        padding: 89px 66px 136px;
        background: #fff;
        .us-title {
          width: 160px;
          height: 78px;
          margin-bottom: 54px;
          background: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/us-title.png")
            no-repeat;
          background-size: 100% 100%;
        }
        .us-content {
          font-size: 24px;
          color: #333333;
          line-height: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .airport-container {
    .main {
      .main-background {
        padding: 0 33px 52px;
        &-title {
          width: 97px;
          height: 41px;
          margin: 0 0 31px;
        }
        &-text {
          font-size: 12px;
          line-height: 15px;
          > p:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
      .main-banner {
        width: 100%;
        height: 175px;
        padding: 0 33px;
      }
      .main-more {
        width: 100%;
        padding: 16.5px 33px 33px;
        background: transparent;
        .more-item {
          width: 100%;
          margin-bottom: 10px;
          font-size: 12px;
        }
        .more-btn {
          font-size: 12px;
          margin-top: 19.5px;
        }
      }
      .main-exhibition {
        .exhibition-title {
          width: 113.5px;
          height: 37.5px;
          margin: 0 0 2px 33px;
        }
      }
      .main-five {
        padding: 32.5px 33px 0;
        .five-title {
          width: 109px;
          height: 39.5px;
          margin: 0 0 26px;
        }
        .five-box {
          .five-items {
            &:not(:last-child) {
              margin-bottom: 16.5px;
            }
            .five-items-text {
              min-height: 69px;
              padding: 8.5px 9.5px;
              .label {
                font-size: 14px;
                margin-bottom: 9px;
              }
              .summary {
                font-size: 12px;
              }
            }
          }
        }
      }
      .main-influence {
        padding: 33.5px 33px 0;
        .influence-title {
          width: 197px;
          height: 42px;
          margin: 0 0 30px;
        }
        .influence-box {
          .influence-items {
            .items-title {
              min-width: 60px;
              padding: 2px 10px;
              font-size: 14px;
              line-height: 14px;
              margin-bottom: 13px;
            }
            .items-text {
              font-size: 12px;
              line-height: 15px;
              .items-text-t {
                font-size: 12px;
                margin-bottom: 12px;
              }
              .sp-box {
                .sp-items {
                  width: 114px;
                  height: 66.5px;
                  &:not(:last-child) {
                    margin-right: 18.5px;
                  }
                }
              }
            }
          }
        }
      }
      .main-past {
        padding: 50px 33px;
        .past-title {
          width: 91.5px;
          height: 39.5px;
          margin: 0 0 34px;
        }
        .past-box {
          .past-items {
            width: calc((100% - 14.5px) / 2);
            margin-bottom: 32px;
            .items-cover {
              padding-bottom: 19px;
              margin-bottom: 13.5px;
              .cover-tip {
                width: 46.5px;
                height: 15.5px;
                padding-right: 7px;
                font-size: 10px;
                line-height: 10px;
                border-radius: 0 0 0 13px;
                bottom: 13px;
              }
            }
            .items-time {
              font-size: 12px;
              line-height: 12px;
              margin-bottom: 12px;
            }
            .items-conetnt {
              font-size: 12px;
              line-height: 14.5px;
            }
          }
        }
      }
      .main-organization {
        padding: 8.5px 33px 48.5px;
        .organization-title {
          width: 104px;
          height: 39.5px;
          margin: 0 0 25.5px;
        }
        .organization-box {
          &:not(:last-child) {
            margin-bottom: 23.5px;
          }
          .organization-items {
            font-size: 12px;
            line-height: 15px;
            &:not(:last-child) {
              margin-bottom: 23.5px;
            }
            &::after {
              width: 17px;
              height: 17px;
              top: -6px;
              left: -8px;
            }
            .items-title {
              margin-bottom: 13px;
            }
          }
        }
      }
      .main-naming {
        padding: 0 33px 34.5px;
        .naming-title {
          width: 108.5px;
          height: 38.5px;
          margin: 0 0 21.5px;
          background-image: url("https://scheme.timesmedia.com.cn/activity/airport/media-750/naming-title.png");
        }
        .naming-box {
          justify-content: flex-start;
          align-items: flex-start;
          .naming-item {
            width: 39px;
          }
        }
      }
      .main-media {
        padding: 0 33px;
        .media-title {
          width: 76.5px;
          height: 38.5px;
          margin-bottom: 26.5px;
        }
      }
      .main-us {
        padding: 44.5px 33px 68px;
        .us-title {
          width: 80px;
          height: 39px;
          margin-bottom: 27px;
        }
        .us-content {
          font-size: 12px;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
